import {client} from "@/store";
import Vue from "vue";

export default {
    namespaced: true,

    state: {
        support_tickets: []
    },

    mutations: {
        setSupportTicketMarkers(state, value) {
            Vue.set(state, 'support_tickets', [...value]);
        }
    },

    getters: {
        getSupportTicketById: state => id => {
            return state.support_tickets.find(item => item.id === id);
        }
    },

    actions: {
        fetchSupportMapMarkers({ commit, state, dispatch }, data) {
            const markerQuery = `
                query ($type: String, $filter: String, $search: String, $historicFromDate: String, $historicTillDate: String) {
					supportTicketMarkers(type: $type, filter: $filter, search: $search, historicFromDate: $historicFromDate, historicTillDate: $historicTillDate) {
                        id,
                        project_id,
                        color,
						mainProjectLineAmount,
						project {
						    company {
						       id,
						       coordinates,
						       visitingaddress_lng,
						       visitingaddress_lat
						    }
						}
					}
                }
            `;

            return new Promise((resolve, reject) => {
                commit('setLoading', null, { root: true });
                client.query(markerQuery, { ...data }).then(result => {
                    commit('setIdle', null, { root: true });
                    commit('setSupportTicketMarkers', result.supportTicketMarkers);
                    resolve(result.supportTicketMarkers);
                });
            });
        },

        getSupportTicketById({ commit, state, dispatch }, id) {
            const supportTicketQuery = `
                query ($id: ID!) {
                    supportTicket(id: $id) {
                        project_id,
                        type,
                        resolving_scope,
                        phase,
                        reason,
                        remark,
                        invoice_on_hold,
                        created_at,
                        cancellation_data,
                        support_actions_description,
                        resolved_at,
                        resolved_remarks,
                        appointment_id,
                        appointment {
                            id,
                            type,
                            user_id,
                            date,
                            planned_start_time,
                            planned_end_time,
                            deleted_at,
                            teamLeader, {
                                display_name
                            },
                            teamMembers, {
                                display_name
                            },
                            historicTeamMembers {
                                display_name
                            }
                        },
                        resolve_appointment_id,
                        resolve_appointment {
                            id,
                            type,
                            user_id,
                            date,
                            planned_start_time,
                            planned_end_time,
                            deleted_at,
                            teamLeader, {
                                display_name
                            },
                            teamMembers, {
                                display_name
                            },
                            historicTeamMembers {
                                display_name
                            }
                        },
                        project {
                            id,
                            name,
                            number,
                            gripp_projectphase_id,
                            startdate,
                            customfield_uitvoerendeploeg,
                            customfield_uitvoeringdatum,
                            customfield_begintijduitvoering2,
                            customfield_eindtijduitvoering2,
                            customfield_uitvoeringnotitie,
                            customfield_uitvoeringafspraakgoogle,
                            customfield_extrabusuitvoeringdatum,
                            customfield_extrabusuitvoeringbegintijd2,
                            customfield_extrabusuitvoeringeindtijd2,
                            customfield_extrabusuitvoeringbus,
                            customfield_extrabusuitvoeringafspraakgoogle,
                            customfield_ventilatieroostersuitvoeringdatum,
                            customfield_ventilatieroostersuitvoeringbegintijd2,
                            customfield_ventilatieroostersuitvoeringeindtijd2,
                            customfield_ventilatieroostersuitvoeringbus,
                            customfield_uitvoeringventilatieroostersgoogle,
                            customfield_impregnerenuitvoeringdatum,
                            customfield_impregnerenuitvoeringbegintijd2,
                            customfield_impregnerenuitvoeringeindtijd2,
                            customfield_impregnerenuitvoeringbus,
                            customfield_uitvoeringimpregnerengoogle,
                            customfield_hoogwerkeruitvoeringdatum,
                            customfield_hoogwerkeruitvoeringcheck,
                            customfield_uitvoeringserviceeindtijd2,
                            customfield_uitvoeringservicebegintijd2,
                            customfield_uitvoeringservicedatum,
                            customfield_uitvoeringserviceploeg,
                            customfield_supportnotitie,
                            customfield_uitvoeringsupportgoogle,
                            customfield_supportextradatum,
                            customfield_supportextrabegintijd,
                            customfield_supportextraeindtijd,
                            customfield_supportextraploeg,
                            customfield_supportextragoogle,
                            customfield_supporthoogwerker,
                            customfield_supportbevestigdpeinemann,
                            company {
                                id,
                                companyname,
                                customernumber
                            },
                            projectLines {
                                id,
                                searchname,
                                amount,
                                unit,
                                product_id
                            },
                            additionalProjects {
                                id,
                                name,
                                projectLines {
                                    id,
                                    searchname,
                                    amount,
                                    unit,
                                    product_id						
                                }
                            },
                            appointments {
                                id,
                                type,
                                user_id,
                                date,
                                planned_start_time,
                                planned_end_time,
                                deleted_at,
                                teamLeader, {
                                    display_name
                                },
                                teamMembers, {
                                    display_name
                                },
                                historicTeamMembers {
                                    display_name
                                },
                            }
                        }
                    }
                }
            `;

            return new Promise((resolve, reject) => {
                commit('setLoading', null, { root: true });
                client.query(supportTicketQuery, { id: id }).then(result => {
                    commit('setIdle', null, { root: true });
                    resolve(result.supportTicket);
                });
            });
        }
    }
}
